// Collections dropdown image: starts on the first collection each time the menu opens,
// cross-fades to the next every few seconds, and follows the link being hovered.
class CollectionsRotator extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.collections-menu__slide')];
    const item = this.closest('.menu-list__list-item');
    this.trigger = item?.querySelector(':scope > .menu-list__link');
    if (this.slides.length < 1 || !this.trigger) return;

    this.index = 0;
    this.links = [...item.querySelectorAll('.collections-menu__link[data-collection]')];
    this.interval = Number(this.dataset.interval) || 3500;

    this.observer = new MutationObserver(() => this.sync());
    this.observer.observe(this.trigger, { attributes: true, attributeFilter: ['aria-expanded'] });

    const list = item.querySelector('.collections-menu__links');
    list?.addEventListener('pointerover', (event) => {
      const link = event.target.closest('[data-collection]');
      const i = this.slides.findIndex((slide) => slide.dataset.collection === link?.dataset.collection);
      if (i > -1) {
        this.stop();
        this.show(i);
      }
    });
    list?.addEventListener('pointerleave', () => this.sync());
    this.sync();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.stop();
  }

  sync() {
    if (this.trigger.getAttribute('aria-expanded') === 'true') {
      this.show(0);
      this.start();
    } else {
      this.stop();
    }
  }

  start() {
    this.stop();
    if (this.slides.length > 1) {
      this.timer = setInterval(() => this.show((this.index + 1) % this.slides.length), this.interval);
    }
  }

  stop() {
    clearInterval(this.timer);
  }

  show(i) {
    this.index = i;
    this.slides.forEach((slide, k) => slide.classList.toggle('is-active', k === i));
    const handle = this.slides[i]?.dataset.collection;
    this.links.forEach((link) => link.classList.toggle('is-current', link.dataset.collection === handle));
  }
}

if (!customElements.get('collections-rotator')) customElements.define('collections-rotator', CollectionsRotator);
